var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiObserveVisibility',{on:{"click":_vm.processClickAdd,"visible":_vm.processViewAdd}},[_c('div',{attrs:{"id":_vm.blockId,"data-adv-smi-two":"1"}},[_c('a',{attrs:{"href":"https://smi2.ru/"}},[_vm._v("Новости СМИ2")])])])}
var staticRenderFns = []

export { render, staticRenderFns }